import { useSuspenseQuery } from "@tanstack/react-query";
import { type LendingApiClient, useApi } from "@lending/lib/api";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";

function getPersonalLoanProductsQueryOptions($api: LendingApiClient) {
  return $api.queryOptions(
    "get",
    "/v2/lending/personal_loan_products/",
    {},
    STANDARD_QUERY_CACHE_CONFIG
  );
}

function useGetPersonalLoanProductsQuery() {
  const $api = useApi();
  const query = useSuspenseQuery(getPersonalLoanProductsQueryOptions($api));

  return {
    personalLoanProductsData: query.data,
  };
}

export { useGetPersonalLoanProductsQuery, getPersonalLoanProductsQueryOptions };
